import React, { useContext, useEffect, useState } from "react";
import { Tooltip, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../theme/ThemeContext";

const DeleteLogo = () => {
  const [isShown, setIsShown] = React.useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  return (
    <>
      <Tooltip title={t("dataTableDelete")}>
        <Box
          className={darkMode ? "iconButton_dark" : "iconButton"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isHovered ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="14"
              viewBox="0 0 22.313 23.775"
            >
              <path
                id="Subtraction_140"
                data-name="Subtraction 140"
                d="M14719.6-21880.227h-8.884a4.06,4.06,0,0,1-1.6-.318,4.257,4.257,0,0,1-1.357-.9,4.276,4.276,0,0,1-.9-1.357,4.215,4.215,0,0,1-.319-1.6v-13.6H14705a1,1,0,0,1-1-1,1,1,0,0,1,1-1h5.349v-1.094a2.9,2.9,0,0,1,.22-1.115,2.836,2.836,0,0,1,.633-.939,2.886,2.886,0,0,1,.939-.633,2.9,2.9,0,0,1,1.116-.221h3.8a2.853,2.853,0,0,1,1.111.221,2.872,2.872,0,0,1,.945.633,2.954,2.954,0,0,1,.632.939,3,3,0,0,1,.22,1.115v1.094h5.344a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-1.539v13.6a4.194,4.194,0,0,1-1.221,2.957A4.218,4.218,0,0,1,14719.6-21880.227Zm-1.9-13.309a1,1,0,0,0-1,1v6.344a1,1,0,0,0,1,1,1,1,0,0,0,1-1v-6.344A1,1,0,0,0,14717.7-21893.535Zm-5.079,0a1,1,0,0,0-1,1v6.344a1,1,0,0,0,1,1,1,1,0,0,0,1-1v-6.344A1,1,0,0,0,14712.618-21893.535Zm.632-8.465a.9.9,0,0,0-.346.066.958.958,0,0,0-.291.2.891.891,0,0,0-.2.291.982.982,0,0,0-.066.352v1.094h5.618v-1.094a.845.845,0,0,0-.071-.352.865.865,0,0,0-.192-.291,1.064,1.064,0,0,0-.3-.2.9.9,0,0,0-.347-.066Z"
                transform="translate(-14703.999 21904.002)"
                fill={darkMode ? "#fff" : "#474a4e"}
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="14"
              viewBox="0 0 22.313 23.779"
            >
              <path
                id="Union_558"
                data-name="Union 558"
                d="M14710.713-21628.223a4.116,4.116,0,0,1-1.6-.32,4.128,4.128,0,0,1-1.353-.9,4.162,4.162,0,0,1-.907-1.357,4.221,4.221,0,0,1-.315-1.6v-13.6H14705a1,1,0,0,1-1-1,1,1,0,0,1,1-1h5.347v-1.1a2.878,2.878,0,0,1,.218-1.113,2.876,2.876,0,0,1,.631-.941,2.919,2.919,0,0,1,.945-.635,2.96,2.96,0,0,1,1.113-.219h3.8a3.007,3.007,0,0,1,1.114.219,2.9,2.9,0,0,1,.94.635,2.889,2.889,0,0,1,.63.941,2.882,2.882,0,0,1,.223,1.113v1.1h2.761a.14.14,0,0,1,.049-.006.137.137,0,0,1,.049.006h2.489a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-1.538v13.6a4.192,4.192,0,0,1-1.223,2.955,4.176,4.176,0,0,1-2.95,1.223Zm-2.173-4.178a2.208,2.208,0,0,0,.162.836,2.191,2.191,0,0,0,.474.7,2.147,2.147,0,0,0,.706.473,2.149,2.149,0,0,0,.831.168h8.891a2.167,2.167,0,0,0,1.532-.641,2.181,2.181,0,0,0,.641-1.537v-13.6h-13.236Zm9.428-15.6v-1.1a.827.827,0,0,0-.071-.348.792.792,0,0,0-.2-.293.826.826,0,0,0-.293-.2.961.961,0,0,0-.349-.07h-3.809a.977.977,0,0,0-.348.07.876.876,0,0,0-.294.2.968.968,0,0,0-.2.293.9.9,0,0,0-.065.342v1.1Zm-1.271,13.8v-6.348a1,1,0,0,1,1-1,1,1,0,0,1,1,1v6.348a1,1,0,0,1-1,1A1,1,0,0,1,14716.7-21634.193Zm-5.075,0v-6.348a1,1,0,0,1,1-1,1,1,0,0,1,1,1v6.348a1,1,0,0,1-1,1A1,1,0,0,1,14711.621-21634.193Z"
                transform="translate(-14704.002 21652.002)"
                fill={darkMode ? "#fff" : "#474a4e"}
                opacity="0.8"
              />
            </svg>
          )}
        </Box>
      </Tooltip>
    </>
  );
};
export default DeleteLogo;
